export function start(data) {
  return {
    type: "START_SONG_STREAM",
    payload: {
      ...data,
    },
  };
}

export function end() {
  return {
    type: "END_SONG_STREAM",
  };
}
